module.exports = __webpack_public_path__ + "img/ztxh.fe288d18.png";